import Vue from 'vue'
import focusDirective from '~/utils/directives/focus'

Vue.directive('focus', focusDirective)
